import { useParams } from 'react-router-dom';
import { Query } from '../../../components/Query';
import { api } from '../../../lib/api';
import { styled, Typography } from '@mui/material';
import { Section } from '../../../components/Section';
import { Button } from '../../../components/Button';
import { Info } from '../../FicheInscriptionPages/FicheInscriptionPreview/components/Info';

function FicheRenseignementPreview() {
    const params = useParams();
    if (!params.ficheRenseignementId) {
        return <div>Missing parameters in URL</div>;
    }

    const ficheRenseignementId = params.ficheRenseignementId;

    return (
        <Query
            queryKey={['fiches-renseignements-entries', ficheRenseignementId]}
            apiCall={() => api.getFicheRenseignementEntry(ficheRenseignementId)}
        >
            {(data) => {
                return (
                    <ContentContainer className="no-padding-print">
                        <Row>
                            <LogoContainer>
                                <Logo src="https://www.esaj.asso.fr/assets/images/logo-sos.svg" />
                            </LogoContainer>
                            <Column>
                                <Title variant="h2">
                                    Fiche de renseignement {data.firstName.toUpperCase()}{' '}
                                    {data.lastName.toUpperCase()}
                                </Title>
                            </Column>
                        </Row>

                        <Section variant="h2" title="Informations personnelles">
                            <Info label="Prénom" value={data.firstName.toUpperCase()} />
                            <Info label="Nom de famille" value={data.lastName.toUpperCase()} />
                            <Info label="Date de naissance" value={data.birthdate} />
                            <Info label="Lieu de naissance" value={data.placeOfBirth} />
                            <Info label="Adresse e-mail" value={data.email} />
                            <Info label="Téléphone portable" value={data.phoneNumber} />
                        </Section>
                        <Section variant="h2" title="Documents">
                            <Info label="Type de document" value={data.idDocument} />
                            <Info label="Numéro de document" value={data.idNumber} />
                            <Info
                                label="Date d'expiration du document"
                                value={data.idExpirationDate}
                            />
                            {data.visaNumber && (
                                <Info label="Numéro de visa" value={data.visaNumber} />
                            )}
                        </Section>
                        <Section variant="h2" title="Informations des parents ou tuteurs">
                            <Section variant="h3" title="Informations du parent ou tuteur 1">
                                <Info label="Nom" value={data.parent1Name} />
                                <Info label="Adresse" value={data.parent1Address} />
                                <Info label="Contact" value={data.parent1Contact} />
                            </Section>
                            <Section variant="h3" title="Informations du parent ou tuteur 2">
                                <Info label="Nom" value={data.parent2Name} />
                                <Info label="Adresse" value={data.parent2Address} />
                                <Info label="Contact" value={data.parent2Contact} />
                            </Section>
                        </Section>

                        <Row className="not-printable">
                            <Button fullWidth onClick={handlePrint} variant="contained">
                                Sauvegarder une copie de la fiche de renseignement
                            </Button>
                        </Row>
                    </ContentContainer>
                );
            }}
        </Query>
    );

    function handlePrint() {
        window.print();
    }
}

const Logo = styled('img')(({ theme }) => ({
    width: '100px',
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
}));
const Row = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: 1,
    alignItems: 'center',
}));

const LogoContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing(4),
}));

const ContentContainer = styled('div')(({ theme }) => ({
    flex: 1,
    padding: theme.spacing(4),
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
}));

const Title = styled(Typography)(({ theme }) => ({
    textAlign: 'center',
    paddingBottom: theme.spacing(1),
}));

const Column = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
}));

export { FicheRenseignementPreview };
